const getters = {
  //系统配置app
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  //用户信息
  token: state => state.admin.token,
  avatar: state => state.admin.avatar,
  name: state => state.admin.name,
  //权限菜单
  resource: state => state.resource.menus,
  //下载查看图片地址
  // fileUrl:state =>'http://47.99.85.203:8084/purchase/file/downloadFile?id=',//图片默认地址
  // fileUrl:state =>'https://epp.yzstc.cn/purchase/file/downloadFile?id=',//https图片默认地址
  // fileUrl:state =>'http://epp.yzstc.cn/purchase/file/downloadFile?id=',//http图片默认地址（测试环境）
  //http图片默认地址（生产环境）
  fileUrl:state =>'https://epp.yazhou-bay.com/purchase/file/downloadFile',
  proFileUrl:state =>'https://epp.yazhou-bay.com/purchase/file/downloadProFile',
  purchaseDownLoadOfferFile:state =>'https://epp.yazhou-bay.com/purchase/file/purchaseDownLoadOfferFile',
  //测试环境
  // fileUrl:state =>'http://epp.test.yzbays.cn/purchase/file/downloadFile',
  // proFileUrl:state =>'http://epp.test.yzbays.cn/purchase/file/downloadProFile',
  // purchaseDownLoadOfferFile:state =>'http://epp.test.yzbays.cn/purchase/file/purchaseDownLoadOfferFile',
  // fileUrl:state =>'http://127.0.0.1:8089/purchase/file/downloadFile',
  // proFileUrl:state =>'http://127.0.0.1:8089/purchase/file/downloadProFile',
  // purchaseDownLoadOfferFile:state =>'http://127.0.0.1:8089/purchase/file/purchaseDownLoadOfferFile',

  //authing配置信息
  //测试环境
  // eppUrl:state => 'http://epp.test.yzbays.cn/',
  // authingAppid:state => '66bad11e55d8dfe36d4a3cdf',
  // authingRedirectUri:state => 'https://newdzcg.yzbays.cn/login?app_id=',
  // authingLogonUrl:state => 'https://newdzcg.yzbays.cn/loginOut?app_id=',
  //生产环境
  eppUrl:state => 'https://epp.yazhou-bay.com/',
  authingAppid:state => '60546e7d4040549d15f474bb',
  authingRedirectUri:state => 'https://portal.yazhou-bay.com/page/ssoLogin?appId=',
  authingLogonUrl:state => 'https://portal.yazhou-bay.com/page/loginOut?appId=',

}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js